import { OnSchedHelpers } from ".";

export const CalendarCustomEvents = {
  ViewChange: (e, element) => {
    const detail = {
      start: e.view.currentStart,
      end: e.view.currentEnd,
      view: Object.keys(OnSchedHelpers.CalendarViews).find(k => OnSchedHelpers.CalendarViews[k] === e.view.type)
    }

    const elCalendar = document.getElementById(element.id);
    const calendarViewEvent = new CustomEvent("calendarViewChange", { detail });

    elCalendar.dispatchEvent(calendarViewEvent);
  },
  DateChange: (e, element) => {
    const elCalendar = document.getElementById(element.id);
    const changeDatesEvent = new CustomEvent("calendarDateChange", { detail: e });

    elCalendar.dispatchEvent(changeDatesEvent);
  },
  EventsLoaded: (element, arr, info) => {
    const events = arr.map(e => {
      if (e.object === 'appointment') {
        e.calendar = 'OnSched';
      }
      else {
        e.calendar = OnSchedHelpers.CalendarReasonCodes[e.extendedProps.reasonCode].calendar;
      }
      return e;
    })
    const calendarEventsDetail = { detail: { events, date: info } };
    const calendarEventsCustomEvent = new CustomEvent("calendarEvents", calendarEventsDetail);
    const elCalendar = document.getElementById(element.id);

    elCalendar.dispatchEvent(calendarEventsCustomEvent);
  },
  CreateAppointment: (element, e) => {
    const elCalendar = document.getElementById(element.id);

    const appointmentObject = {
      locationId: element.params.locationId ? element.params.locationId : '',
      resourceId: e.resource?._resource?.id ? e.resource._resource.id : '',
      startDateTime: e.dateStr,
      date: e.date,
    }

    elCalendar.dispatchEvent(new CustomEvent("createAppointment", { detail: appointmentObject }))
  },
  SelectAppointment: (element, appointmentResp) => {
    const elCalendar = document.getElementById(element.id);

    elCalendar.dispatchEvent(new CustomEvent("selectAppointment", { detail: appointmentResp }));
  }
}

export const UtilityCustomEvents = {
  ResizeElement: (element, data) => {
    const referrers = document.referrer.match(/^.+:\/\/[^\/]+/)
    const referrer = referrers && referrers.length ? referrers[0] : null

    if (referrer && data?.height > 0) {
      const detail = {
        onschedElementResize: true,
        element: element.type,
        elementDimensions: {
          width: data.width,
          height: data.height,
          top: data.top,
          left: data.left
        }
      }

      window.parent.postMessage(detail, referrer);
    }
  },
  ElementLoaded: (element) => {
    const el = document.getElementById(element.id);

    const event = new CustomEvent("elementLoaded", {
      detail: { loaded: true, element: element.type }
    });

    el.dispatchEvent(event)
  }
}
